const CategoryItem = ({
  category,
  checkedItems,
  handleCheckboxChange,

  level = 0,
}) => {
  return (
    <div
      className="checkbox-filter mt-2"
      style={{ marginRight: `${level * 0.75}rem` }}
    >
      <div className="checkbox-wrapper">
        <label className="flex items-center gap-2 text-ws-gray-800 text-sm">
          <input
            className="text-base"
            type="checkbox"
            name={category?.name}
            onChange={() => handleCheckboxChange(category.id, category?.name)}
            checked={checkedItems[category.id] || false}
          />
          {category?.name}
        </label>
      </div>
      {checkedItems[category.id] && category?.childs?.length > 0 && (
        <div className={`mt-2`}>
          {category.childs.map((child) => (
            <CategoryItem
              key={child.id}
              category={child}
              checkedItems={checkedItems}
              handleCheckboxChange={handleCheckboxChange}
              level={level + 1}
            />
          ))}
        </div>
      )}
    </div>
  );
};
export default CategoryItem;
